<div id="__next">
  <app-spinner *ngIf="isLoading == true"></app-spinner>
  <div>
    <div></div>
    <div
      style="background-color: rgba(255, 255, 255, 0.26)"
      class="css-1ttwp26"
    >
      <div class="MuiBox-root css-52jbj8">
        <div class="css-pl6neh">
          <div class="css-19y9rst" style="opacity: 1; transform: none">
            <span
              style="
                box-sizing: border-box;
                display: block;
                overflow: hidden;
                width: initial;
                height: initial;
                background: none;
                opacity: 1;
                border: 0;
                margin: 0;
                padding: 0;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
              "
            >
              <img
                alt="banner image"
                sizes="100vw"
                src="{{
                  userData?.coverPic
                    ? userData?.coverPic
                    : '../../../../assets/images/cover_image.svg'
                }}"
                decoding="async"
                data-nimg="fill"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  box-sizing: border-box;
                  padding: 0;
                  border: none;
                  margin: auto;
                  display: block;
                  width: 0;
                  height: 0;
                  min-width: 100%;
                  max-width: 100%;
                  min-height: 100%;
                  max-height: 100%;
                  object-fit: cover;
                "
            /></span>
          </div>
        </div>
        <div class="css-rc2v4o">
          <!-- style="opacity: 1; top: 90px; height: 168px; width: 168px;background: white;" -->
          <img
            src="{{
              userData?.profilePic
                ? userData?.profilePic
                : '../../../../../../assets/images/profile_pic.svg'
            }}"
            alt="profile image"
            class="profile-image"
          />
        </div>
        <div class="pro-logo">
          <img
            src="{{
              userData?.logo
                ? userData?.logo
                : '../../../../../../assets/images/pro_logo.svg'
            }}"
            alt="profile image"
          />
          <!-- <span class="shares" (click)="onShareLinks()">
          <img style="height: 25px;
            width: 30px;border-radius: 0"
            src="../../../../../../assets/images/Share1.svg"
            alt="share"
          /> 
         </span>  -->
        </div>
        <div class="MuiBox-root css-15cvuqi">
          <div class="share_link">
            <!-- {{userData?.cardName ? userData?.cardName : '--'}} -->
            <p class="user_name">
              {{
                userData?.cardName?.length > 20
                  ? userData.cardName.substring(0, 20) + "..."
                  : userData.cardName
                  ? userData?.cardName
                  : "--"
              }}
            </p>

            <!-- <p class="shares" (click)="onShareLinks()">Share link</p> -->
          </div>
          <p class="user_job" *ngIf="userData?.cardJobTitle">
            {{ userData?.cardJobTitle ? userData?.cardJobTitle : "--" }}
            <span *ngIf="userData?.cardCompany"> at </span>
            <span *ngIf="userData?.cardCompany">{{
              userData?.cardCompany ? userData?.cardCompany : "--"
            }}</span>
          </p>

          <p
            class="align-items-center text-center"
            style="font-weight: 500"
            *ngIf="userData?.description"
          >
            {{ userData?.description }}
          </p>

          <!-- <p class="user_job">{{userData?.description ? userData?.description : '--'}}</p> -->
          <!-- <p style="color: #000;font-size: 21px;font-weight: 500;">{{userData?.name}}</p> -->
          <div class="row">
            <div class="col-6">
              <button
                class="mt-3 addContact"
                id="downloadButtonNormal"
                (click)="downloadVCF()"
              >
                Save Contact
              </button>
            </div>
            <div class="col-6">
              <button
                *ngIf="isConnection == true"
                class="connect mt-3"
                #resetBtn
              >
                Connected
              </button>
              <button
                *ngIf="isConnection == false"
                class="connect mt-3"
                #resetBtn1
                (click)="openModalReset(UserId, emailform, resetBtn1)"
              >
                Connect
              </button>
            </div>
          </div>
          <div class="content_links w-100 p-4" style="margin-top: -5px">
            <div>
              <ng-container>
                <div class="row">
                  <div
                    *ngFor="let data of linkList | filterdata; let index; as: i"
                    class="col-4 text-center p-1"
                    [ngClass]="{
                      'align-items-center col-12':
                        data.ishighlight === true ||
                        data.isEmbeddedVideo === true,
                      'mb-2 ': data.isEmbeddedVideo === true
                    }"
                  >
                    <div
                      [ngClass]="{
                        'normal ':
                          data.ishighlight === false &&
                          data.isEmbeddedVideo === false
                      }"
                    >
                      <span
                        (click)="redirectTo(hrefFunction(data))"
                        *ngIf="
                          data.ishighlight === false &&
                          data.isEmbeddedVideo === false &&
                          data.isExpandableText === false
                        "
                      >
                        <img
                          class="highlighted_link cursor"
                          height="50px"
                          width="50px"
                          [src]="data.webIcon"
                        />
                        <p class="text-center link_text m-0 mt-1">
                          {{
                            data?.userTitle?.length > 13
                              ? data.userTitle.substring(0, 13) + "..."
                              : data.userTitle
                          }}
                        </p>
                      </span>
                      <span
                        *ngIf="
                          data.ishighlight === true &&
                          data.isExpandableText === true
                        "
                      >
                        <div>
                          <mat-accordion
                            displayMode=""
                            multi
                            class="mat-table"
                            is-open="true"
                            style="background: #f5f5f4"
                          >
                            <mat-expansion-panel>
                              <mat-expansion-panel-header
                                class="mat-row"
                                style="
                                  background-color: #f5f5f4;
                                  align-items: center;
                                  gap: 10px;
                                "
                              >
                                <!-- <span class="mr-4"><img height="20px" width="20px"
                                    src="{{data?.webIcon}}"
                                    alt="expan"padding: 0 24px 16px;
                                  /></span> -->
                                <img
                                  class="highlighted_link cursor"
                                  style="height: 40px; width: 45px"
                                  [src]="data.webIcon"
                                />
                                <span
                                  class="mat-cell d-block m-0 t1 text-left mt-2 ml-1"
                                  >{{ data.title }}</span
                                >
                              </mat-expansion-panel-header>
                              <mat-accordion>
                                <span class="expand" style="text-align: left">
                                  <p [innerText]="data?.link"></p>
                                </span>
                              </mat-accordion>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                      </span>
                      <a
                        *ngIf="
                          data.ishighlight === true &&
                          data.isEmbeddedVideo === false &&
                          data.isExpandableText === false
                        "
                        (click)="redirectTo(hrefFunction(data))"
                        data-rel="external"
                        class="d-flex align-items-center p-2 highlight"
                      >
                        <img
                          class="highlighted_link cursor"
                          height="60px"
                          width="60px"
                          [src]="data.webIcon"
                        />
                        <div class="ml-2">
                          <p class="d-block m-0 t1 text-left">
                            {{
                              data?.userTitle?.length > 20
                                ? data.userTitle.substring(0, 20) + "..."
                                : data.userTitle
                            }}
                          </p>

                          <p class="d-block m-0 t2 text-left">
                            {{
                              data?.description?.length > 50
                                ? data.description.substring(0, 50) + "..."
                                : data.description
                            }}
                          </p>
                        </div>
                      </a>

                      <div class="_iframe" [innerHtml]="data.url"></div>
                      <!-- <p style="font-size: 8px;">{{hrefFunction(data)}}</p> -->
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- <p class="text-center">v2.1 <span style="font-size: 8px;">{{userAgent}}</span></p> -->
        <!-- <div class="powered">
              <p class="text-center" style="font-size: 10px;
              width: 100%;
              display: block;">Powered by  <img style="height: 20px;
                width: 30px;"
                src="../../../../../../assets/images/wetap_logo.svg"
                alt="logo"
              /> 
            </div> -->
        <div class="row" style="display: flex; justify-content: center">
          <div
            *ngIf="!userData.isRemoveBranding"
            class="mb-1 cursor ml-4"
            style="font-size: 10px; display: block"
            (click)="openWebsite()"
          >
            Get your Own Smart Business card on
            <img
              style="height: 20px; width: 30px"
              src="../../../../../../assets/images/wetap_logo.svg"
              alt="logo"
            />
          </div>
          <!-- <div
            *ngIf="!userData.isRemoveBranding"
            class="mr-4"
            style="
              font-size: 10px;
              width: 40%;
              display: flex;
              justify-content: end;
              cursor: pointer;
            "
            (click)="openWebsiteZimble()"
          >
            Powered by
            <img
              style="height: 20px; width: 30px"
              src="../../../../assets/images/zimblel1.png"
              alt="logo"
            />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modalmessage let-modal>
  <div class="modal-body mt-4">
    <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
    <div class="bg_transparent position-relative">
      <div class="container form-card">
        <div class="row">
          <div>
            <button
              (click)="modal.dismiss('Cross click')"
              class="addCandidateBtn btn"
            >
              X
            </button>
          </div>
        </div>
      </div>
      <div class="container card">
        <div class="row card-margin">
          <div class="col-md-12 mt-3">
            <div class="text-center">
              <p class="name mb-0 mt-2">
                <span>Coming soon</span>
              </p>
              <!-- <p class="org mb-0"><span>Maria Wales</span></p> -->
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emailform let-modal>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="modal-body">
    <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
    <div class="bg_transparent position-relative">
      <div
        style="float: right; cursor: pointer"
        (click)="modal.dismiss('Cross click')"
      >
        <img
          src="../../../../assets/images/cross.svg"
          alt="cross"
          width="15px"
        />
      </div>
      <div class="container form-card">
        <div class="row">
          <!-- <div>
            <button
              (click)="closeModal()"
              class="addCandidateBtn btn"
            >
           <span>&times;</span> 
            </button>
          </div> -->
        </div>
      </div>
      <div class="container card modal2">
        <div class="row card-margin"></div>
        <form [formGroup]="userForm">
          <div class="row soc form-nfc">
            <div class="col-md-12">
              <div class="form-group">
                <label for="" class="w-100">Name</label>
                <div class="mb-3">
                  <div class="emailImgSet">
                    <img
                      src="../../../../assets/images/user.svg"
                      alt="arrow-left"
                      width="20px"
                      height="20px"
                    />

                    <input
                      formControlName="name"
                      [ngClass]="{ nameclass: otpcheck == 400 }"
                      type="text"
                      placeholder="Enter your name"
                      class="w-100 form-control email-form"
                    />
                  </div>
                  <div
                    *ngIf="
                      userForm.controls['name'].invalid &&
                      (userForm.controls['name'].dirty ||
                        userForm.controls['name'].touched)
                    "
                    class="errorinput text-left"
                  >
                    <div *ngIf="userForm.controls['name'].errors.required">
                      *Name is required.
                    </div>
                  </div>
                </div>
                <!-- <label for="" class="w-100">Email</label> -->
                <!-- <p class="modal-heading">Email</p> -->
                <label for="" class="w-100">Email</label>
                <div class="emailImgSet">
                  <img
                    src="../../../../../../assets/images/email.svg"
                    alt="arrow-left"
                    width="20px"
                    height="20px"
                  />
                  <input
                    formControlName="email"
                    [ngClass]="{ nameclass: otpcheck == 400 }"
                    type="text"
                    placeholder="Enter your email"
                    class="w-100 form-control email-form"
                  />
                </div>
                <div
                  *ngIf="
                    userForm.controls['email'].invalid &&
                    (userForm.controls['email'].dirty ||
                      userForm.controls['email'].touched)
                  "
                  class="errorinput text-left"
                >
                  <div *ngIf="userForm.controls['email'].errors.required">
                    *Email is required.
                  </div>
                  <div *ngIf="userForm.controls['email'].errors.pattern">
                    *Invalid email .
                  </div>
                </div>
                <div class="mt-3">
                  <label for="" class="w-100">Phone number(Optional)</label>
                  <div class="emailImgSet">
                    <!-- <img src="../../../../../../assets/images/email.svg"  alt="arrow-left" width="20px" height="20px"> -->
                    <span>
                      <select
                        style="border: none"
                        formControlName="selectedCountryCode"
                        [ngClass]="{ nameclass: otpcheck == 400 }"
                        class="form-control-select"
                      >
                        <option value="+91" selected="selected">+91</option>
                        <option value="+1">+1</option>
                        <!-- <option *ngFor="let item of schoolList" [value]="item._id">{{item.title}}</option> -->
                      </select>
                    </span>
                    <input
                      formControlName="phoneNumber"
                      [ngClass]="{ nameclass: otpcheck == 400 }"
                      type="text"
                      (keypress)="onlyNumberKey($event)"
                      minlength="10"
                      maxlength="16"
                      placeholder="Enter Phone Number"
                      class="w-100 form-control email-form"
                    />
                  </div>

                  <!-- <div *ngIf="userForm.controls['PhoneNumber'].errors.required">
                    *Email is required.
                  </div> -->
                </div>
              </div>
              <div *ngIf="otpcheck == 400">
                <div class="al_inner_form" style="padding: 10px 25px 0px 25px">
                  <div class="margin">
                    <!-- <button style="border: none;
                  background: none; 
                  width: 40px;margin-top:20px;"
                  (click)="back()"
                  >
                  <img src="../../../../../../assets/images/back_icon.svg"  alt="arrow-left" width="40px">
                  
                  </button> -->
                    <!-- <h3 style="text-align: center; font-size: 20px; font-weight: 600;margin-top: -30px;">
                    OTP
                  </h3> -->
                  </div>
                  <h2
                    style="font-size: 16px; font-weight: 600; margin-top: 30px"
                  >
                    Enter OTP
                  </h2>
                  <div
                    class="texbox"
                    style="font-size: 14px; margin-top: -15px"
                  >
                    Enter your OTP which have send on your email id
                    <b>{{ otpData.email }}</b>
                  </div>
                  <!-- <form [formGroup]="optForm">
                  <input type="text" maxlength="4" (keypress)="onlyNumberKey($event)" class="form-control verify_no"
                    formControlName="otp_mobile" />
                </form> -->
                  <div class="otp-div" style="margin-top: 30px">
                    <ngx-otp-input
                      [config]="otpInputConfig"
                      class="otpstyle"
                      (otpChange)="handeOtpChange($event)"
                      (fill)="handleFillEvent($event)"
                    >
                    </ngx-otp-input>
                  </div>
                  <p style="cursor: pointer; text-align: center">
                    Didn't recieve the code yet ? <br /><span
                      *ngIf="timeCount != 0"
                      >Please wait for 00:<span *ngIf="timeCount < 10">0</span
                      >{{ timeCount }}</span
                    >
                    <span
                      style="font-size: 13px; font-weight: 600"
                      *ngIf="timeCount == 0"
                      (click)="signupwithEmail()"
                      >Resend OTP</span
                    >
                  </p>
                  <div class="otpBtn mt-4 mb-4">
                    <button
                      class="connectEmail"
                      (click)="verifyOtp()"
                      [disabled]="otp.length < 4"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- *ngIf="userData.isLeadCapture"  -->
            <div class="otpBtn mt-4 mb-4">
              <!-- <span class="pr-2">
              <button class="cancel"
              (click)="closeModal()"
            >
              Cancel
            </button>
            </span> -->
              <span>
                <button
                  *ngIf="otpcheck != 400"
                  class="connectEmail"
                  [disabled]="!userForm.valid"
                  (click)="signup()"
                >
                  Connect
                </button>
              </span>
            </div>
            <!-- <div class="buttonConnect mb-3" *ngIf="!userData.isLeadCapture" >
        <button
       class="connectEmail"
       [disabled]="!userForm.valid"
       
       (click)="signup()"
     >
       Connect
     </button>
   
     </div>     -->
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #signUpform let-modal>
  <div class="modal-body" style="height: 310px">
    <div class="al_inner_form" style="padding: 0px 25px 0px 25px">
      <div class="margin">
        <button
          style="border: none; background: none; width: 40px; margin-top: 20px"
          (click)="closeModal()"
        >
          <img
            src="../../../../../../assets/images/back_icon.svg"
            alt="arrow-left"
            width="40px"
          />
        </button>
        <h3
          style="
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            margin-top: -30px;
          "
        >
          Sign Up
        </h3>
        <form [formGroup]="signForm">
          <div class="row soc form-nfc">
            <div class="col-md-12 mt-4">
              <p style="font-size: 16px; font-weight: 500">Email</p>
              <p style="font-size: 12px; margin-top: -10px">
                Enter your email below
              </p>
              <div class="emailImgSet">
                <img
                  src="../../../../../../assets/images/email.svg"
                  alt="arrow-left"
                  width="20px"
                  height="20px"
                />
                <input
                  formControlName="email"
                  type="text"
                  placeholder="Enter your email"
                  class="w-100 form-control email-form"
                />
                <div
                  *ngIf="
                    signForm.controls['email'].invalid &&
                    (signForm.controls['email'].dirty ||
                      signForm.controls['email'].touched)
                  "
                  class="errorinput text-left"
                  style="margin-top: 61px"
                >
                  <div *ngIf="signForm.controls['email'].errors.required">
                    *Email is required.
                  </div>
                  <div *ngIf="signForm.controls['email'].errors.pattern">
                    *Invalid email .
                  </div>
                </div>
              </div>
              <!-- <div class="form-group" style="margin-top: 20px;">
                <input
                  formControlName="email"
                  type="text"
                  class="w-100 form-control email-form"
                />
                <div
                  *ngIf="
                    signForm.controls['email'].invalid &&
                    (signForm.controls['email'].dirty ||
                      signForm.controls['email'].touched)
                  "
                  class="errorinput text-left"
                >
                  <div *ngIf="signForm.controls['email'].errors.required">
                    *Email is required.
                  </div>
                  <div *ngIf="signForm.controls['email'].errors.pattern">
                    *Invalid email .
                  </div>
                </div>
              </div> -->
            </div>

            <div class="signupBtn mt-4">
              <button
                class="connectEmail"
                [disabled]="!signForm.valid"
                (click)="verifyUserExistByEmail()"
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #signupform let-modal>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="modal-body">
    <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
    <div class="bg_transparent position-relative">
      <div class="container form-card">
        <div class="row">
          <div>
            <!-- <button
              (click)="closeModal()"
              class="addCandidateBtn btn"
            >
           <span>&times;</span> 
            </button> -->
          </div>
        </div>
      </div>
      <div class="container card modal2">
        <div class="row card-margin"></div>
        <h2 class="text-center">Create New Connection</h2>
        <div class="col-12 text-center mb-2 signup">
          <div class="otpBtn mt-2 mb-4">
            <span style="padding-right: 12px">
              <button class="cancel" (click)="closeModal()">Cancel</button>
            </span>
            <button
              class="connectEmail"
              (click)="signupOpenModal(UserId, signUpform, resetBtn1)"
            >
              Sign Up
            </button>
          </div>
          <!-- <button
                  class="connectEmail"
                  (click)="signupOpenModal(UserId, signUpform, resetBtn1)"
                >
                Sign Up
                </button> -->

          <!-- <button href="javascript:void(0)" 
                style="margin-top: 12px;
                color: red;
                text-decoration: underline;"
                (click)="modal.dismiss('Cross click')">
              Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #otpModal let-modal>
  <div class="modal-body">
    <div class="al_inner_form" style="padding: 10px 25px 0px 25px">
      <div class="margin">
        <button
          style="border: none; background: none; width: 40px; margin-top: 20px"
          (click)="back()"
        >
          <img
            src="../../../../../../assets/images/back_icon.svg"
            alt="arrow-left"
            width="40px"
          />
        </button>
        <h3
          style="
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            margin-top: -30px;
          "
        >
          OTP
        </h3>
      </div>
      <h2 style="font-size: 16px; font-weight: 600; margin-top: 30px">
        Enter OTP
      </h2>
      <div class="texbox" style="font-size: 14px; margin-top: -15px">
        Enter your OTP which have send on your email id
        <b>{{ otpData.email }}</b>
      </div>
      <!-- <form [formGroup]="optForm">
        <input type="text" maxlength="4" (keypress)="onlyNumberKey($event)" class="form-control verify_no"
          formControlName="otp_mobile" />
      </form> -->
      <div class="otp-div" style="margin-top: 30px">
        <ngx-otp-input
          [config]="otpInputConfig"
          class="otpstyle"
          (otpChange)="handeOtpChange($event)"
          (fill)="handleFillEvent($event)"
        >
        </ngx-otp-input>
      </div>
      <div class="otpBtn mt-4 mb-4">
        <button
          class="connectEmail"
          (click)="verifyOtp()"
          [disabled]="otp.length < 4"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #passwordModal let-modal>
  <div class="modal-body" style="padding: 30px 30px 0px 30px">
    <div class="margin">
      <button
        style="border: none; background: none; width: 40px"
        (click)="back()"
      >
        <img
          src="../../../../../../assets/images/back_icon.svg"
          alt="arrow-left"
          width="40px"
        />
      </button>
      <h3
        style="
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          margin-top: -30px;
        "
      >
        Password
      </h3>
    </div>
    <div class="al_inner_form">
      <h3 style="font-size: 16px; font-weight: 600">Create a Password</h3>
      <div class="texbox" style="font-size: 14px; margin-top: -15px">
        Enter Your Password below
      </div>
      <div class="img-pas" style="margin: 20px 0px">
        <img
          class="mr-3"
          src="../../../../../../assets/images/padlock.png"
          width="30px"
          height="25px"
        />
        <form [formGroup]="passwordForm" class="password-set">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control verify_no form-pass"
            formControlName="password"
          />
          <i
            alt="show"
            class="far fa-eye eye-show"
            style="font-size: 20px; margin-left: 10px"
            (click)="showPassword = !showPassword"
            *ngIf="showPassword"
          ></i>
          <i
            alt="hide"
            class="far fa-eye-slash eye-hide"
            style="font-size: 20px; margin-left: 10px"
            (click)="showPassword = !showPassword"
            *ngIf="!showPassword"
          ></i>
          <div
            *ngIf="
              passwordForm.controls['password'].invalid &&
              (passwordForm.controls['password'].dirty ||
                passwordForm.controls['password'].touched)
            "
            class="errorinput text-left"
            style="margin-top: 85px"
          >
            <div *ngIf="passwordForm.controls['password'].errors.required">
              *Password is required.
            </div>
            <!-- <div *ngIf="passwordForm.controls['password'].errors.minlength && passwordForm.controls['password'].errors.pattern">*Password must be at least 8 characters</div> -->
            <div
              *ngIf="
                passwordForm.controls['password'].errors.pattern ||
                passwordForm.controls['password'].errors.minlength
              "
              style="margin-left: -38px"
            >
              *Password must be contain 8 characters ,lowercase letter and
              numerical value.
            </div>
          </div>
        </form>
      </div>
      <div class="otpBtn mt-4 mb-4 otpSign">
        <button
          class="connectEmail"
          (click)="signUpUser()"
          [disabled]="!passwordForm.valid"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #locationModal let-modal>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="modal-body">
    <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
    <div class="bg_transparent position-relative">
      <div class="container form-card">
        <div class="row">
          <div></div>
        </div>
      </div>
      <div class="container card modal2">
        <div class="row card-margin"></div>
        <h2 class="text-center" style="font-size: 16px">
          Please enable your location in settings to update your current
          location for your connections.
        </h2>
        <div class="col-12 text-center mb-2 signup">
          <div>
            <button class="connectEmail" (click)="locationCheck(true)">
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #popupEpayment let-modal>
  <app-spinner *ngIf="isLoading"></app-spinner>
  <div class="modal-content">
    <div class="modal-body">
      <app-spinner *ngIf="isLoading1" [type]="'normal'"></app-spinner>
      <div class="bg_transparent position-relative">
        <div class="container form-card">
          <div class="row">
            <div></div>
          </div>
        </div>
        <div class="container card modal2">
          <div class="row card-margin"></div>
          <span style="font-weight: 400; font-size: 11px; color: black">
            Card Name</span
          >
          <p style="font-weight: 500; font-size: 17px; color: black">
            {{ userData?.cardName ? userData?.cardName : "--" }}
          </p>
          <p
            style="
              margin-bottom: 2px;
              font-weight: 400;
              font-size: 11px;
              color: black;
            "
          >
            {{ popData.title }} Details
          </p>
          <span style="font-weight: 500; font-size: 17px; color: black"
            >{{ popData.link }}
            <span (click)="copyLink(popData.link)">
              <img
                style="height: 20px; width: 20px"
                src="../../../../../../assets/images/ic_copy.svg"
                alt="copy"
              />
            </span>
          </span>
          <div
            class="col-12 text-center mb-2 empaymet"
            style="margin-top: 10px"
          >
            <div>
              <button
                class="connectDone"
                (click)="modal.dismiss('Cross click')"
                style="float: right"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
